import { Link } from 'react-router'
import computerIcon from '/img/computer.svg'
import contractEditIcon from '/img/contract_edit.svg'
import developerGuideIcon from '/img/developer_guide.svg'
import errorIcon from '/img/error.svg'
import { Button } from '#app/components/ui/button'
import { Card, CardContent } from '#app/components/ui/card'
import { Icon } from '#app/components/ui/icon'
export default function TenantScreeningRoute() {
	return (
		<div className="w-full min-h-screen overflow-hidden">
			{/* Hero Section */}
			<section className="sm:px-6 px-[15px] md:px-[100px] py-16 lg:py-24">
				<div className=" mx-auto">
					<div className="text-center mb-16">
						<h1 className="text-3xl md:text-5xl lg:text-6xl font-normal font-['Futura_Hv_BT'] text-neutral-800 mb-12">
							Rent Collection
						</h1>
						<h2 className="text-2xl md:text-3xl font-normal font-['Futura_Md_BT'] text-gray-900 mb-6 text-left mx-auto">
							Flexible Payments, Reliable Cash Flow
						</h2>
						<p className="text-lg md:text-xl font-normal font-['Futura_Bk_BT'] text-gray-700 text-left mx-auto leading-relaxed">
							Collecting rent shouldn’t be complicated. TrueTenant gives your
							tenants multiple convenient ways to pay — while ensuring you get
							paid on time, every time.
						</p>
					</div>
					<hr className="border-[#CDCDCD] mt-6" />
				</div>
			</section>

			{/* Why Landlords Trust Our Formula Section */}
			<section className="px-4 sm:px-6 lg:px-[100px]">
				<div className=" mx-auto">
					<div className="text-left mb-12">
						<h2 className="text-2xl md:text-3xl lg:text-4xl font-normal font-['Futura_Md_BT'] text-gray-900 mb-4">
							Payment Options & Rates
						</h2>
					</div>

					<div className=" mx-auto mb-10">
						<div className=" overflow-hidden">
							{/* Table Header */}
							<div className="bg-gray-50  border-b border-[#CDCDCD]">
								<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
									<div className="text-2xl text-gray-900 font-['Futura_Bk_BT'] px-6 py-6 text-center">
										Payment Method
									</div>
									<div className="text-2xl text-gray-900 font-['Futura_Bk_BT'] px-6 py-6 border-x border-[#cdcdcd] text-center">
										Typical Rate / Fee*
									</div>
									<div className="text-2xl text-gray-900 font-['Futura_Bk_BT']  px-6 py-6 text-center">
										Benefits
									</div>
								</div>
							</div>

							{/* Table Rows */}
							<div className="divide-y divide-[#CDCDCD] ">
								{/* E-Transfer Row */}
								<div className=" ">
									<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
										<div className="font-medium text-gray-900 font-['Futura_Md_BT'] px-6 py-6 text-center">
											E-Transfer
										</div>
										<div className="text-gray-700 font-['Futura_Bk_BT'] px-6 py-6 border-x border-[#cdcdcd] text-center">
											Flat fee or free
										</div>
										<div className="text-gray-700 font-['Futura_Bk_BT'] px-6 py-6  text-center">
											Fast, familiar, widely used by tenants
										</div>
									</div>
								</div>

								{/* PAD Row */}
								<div className="">
									<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
										<div className="font-medium text-gray-900 font-['Futura_Md_BT'] px-6 py-6 text-center">
											PAD (Pre-Authorized Debit)
										</div>
										<div className="text-gray-700 font-['Futura_Bk_BT'] px-6 py-6 border-x border-[#cdcdcd] text-center">
											Lowest rate
										</div>
										<div className="text-gray-700 font-['Futura_Bk_BT'] px-6 py-6 text-center">
											Automatic, reliable, best for recurring rent
										</div>
									</div>
								</div>

								{/* Credit Card Row */}
								<div className="">
									<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
										<div className="font-medium text-gray-900 font-['Futura_Md_BT'] px-6 py-6 text-center">
											Credit Card
										</div>
										<div className="text-gray-700 font-['Futura_Bk_BT'] px-6 py-6 border-x border-[#cdcdcd] text-center">
											~2-3% (varies by provider)
										</div>
										<div className="text-gray-700 font-['Futura_Bk_BT'] px-6 py-6 text-center">
											Flexible for tenants, builds rewards/points
										</div>
									</div>
								</div>

								{/* Other Solutions Row */}
								<div className="">
									<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
										<div className="font-medium text-gray-900 font-['Futura_Md_BT'] px-6 py-6 text-center">
											Other Solutions
										</div>
										<div className="text-gray-700 font-['Futura_Bk_BT'] px-6 py-6 border-x border-[#cdcdcd] text-center">
											Custom
										</div>
										<div className="text-gray-700 font-['Futura_Bk_BT'] px-6 py-6 text-center">
											Additional options tailored to your property
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr className="border-[#CDCDCD] mt-6" />
				</div>
			</section>

			{/* The TrueTenant Advantage Section */}
			<section className="px-4 sm:px-6 lg:px-[100px] py-16 lg:py-24">
				<div className=" mx-auto">
					<div className="text-center mb-16">
						<h2 className="text-2xl md:text-3xl lg:text-4xl font-normal font-['Futura_Md_BT'] text-gray-900 mb-8">
							The TrueTenant Advantage
						</h2>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
						{/* Card 1: Continuous Protection */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-8">
								<div className="flex items-center justify-center mx-auto mb-6">
									<img
										src={developerGuideIcon}
										alt="Encrypted"
										className="w-8 h-8 text-white"
									/>
								</div>
								<h3 className="text-xl  font-['Futura_Bk_BT'] text-gray-900 mb-4">
									Faster, on-time rent payments
								</h3>
							</CardContent>
						</Card>

						{/* Card 2: Early Warnings */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-8">
								<div className="flex items-center justify-center mx-auto mb-6">
									<img
										src={contractEditIcon}
										alt="Bar Chart"
										className="w-8 h-8 text-white"
									/>
								</div>
								<h3 className="text-xl  font-['Futura_Bk_BT'] text-gray-900 mb-4">
									Easy for tenants, effortless for landlords
								</h3>
							</CardContent>
						</Card>

						{/* Card 3: Proven Results */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-8">
								<div className="flex items-center justify-center mx-auto mb-6">
									<img
										src={computerIcon}
										alt="Emergency Home"
										className="w-8 h-8 text-white"
									/>
								</div>
								<h3 className="text-xl font-['Futura_Bk_BT'] text-gray-900 mb-4">
									Clear reporting for every payment collected
								</h3>
							</CardContent>
						</Card>

						{/* Card 4: Smart Decisions */}
						<Card className="bg-white border border-[#AEAEAE] shadow-none rounded-xl text-center py-0">
							<CardContent className="p-8">
								<div className="flex items-center justify-center mx-auto mb-6">
									<img
										src={errorIcon}
										alt="Published With Changes"
										className="w-8 h-8 text-white"
									/>
								</div>
								<h3 className="text-xl  font-['Futura_Bk_BT'] text-gray-900 mb-4">
									Lower costs with optimised payment rates
								</h3>
							</CardContent>
						</Card>
					</div>

					<div className=" mx-auto text-center mt-20">
						<Button asChild className="rounded-full">
							<Link to="/signup" className="flex items-center gap-2">
								Start Now
								<Icon name="arrow-right" className="w-5 h-5" />
							</Link>
						</Button>
					</div>
				</div>
			</section>
		</div>
	)
}
